import { notification } from 'antd/lib'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { UseMutateFunction, useMutation, useQueryClient } from 'react-query'

import BlocktrainApi from './api'
import { QUERY_KEYS } from '../../api'
import { AxiosErrorType, UpdateBlocktrainStatusPayload } from '../../types'

const { statusUpdate } = BlocktrainApi

interface UseUpdateBlocktrainStatusReturn {
  updateBlocktrainStatus: UseMutateFunction<
    UpdateBlocktrainStatusPayload,
    AxiosErrorType,
    UpdateBlocktrainStatusPayload,
    unknown
  >
  updateBlocktrainStatusIsFetching?: boolean
}

const useUpdateBlocktrainStatus = (): UseUpdateBlocktrainStatusReturn => {
  const { t } = useTranslation()
  const [updateBlocktrainStatusIsFetching, setUpdateBlocktrainStatusIsFetching] =
    useState<boolean>()

  const queryClient = useQueryClient()

  const onSuccess = () => {
    notification.success({
      message: t('status_updated_success'),
    })
    queryClient.invalidateQueries(QUERY_KEYS.BLOCKTRAIN)
    queryClient.invalidateQueries(QUERY_KEYS.BLOCKTRAINS)
    queryClient.invalidateQueries(QUERY_KEYS.BLOCKTRAIN_STATUS_COUNT)
    setUpdateBlocktrainStatusIsFetching(false)
  }

  const onError = (err: AxiosErrorType) => {
    setUpdateBlocktrainStatusIsFetching(false)
    if (err.status === 404) {
      console.error('Route not found', { err })
    }
    const errorResponse = err.data.error as {
      type: string
      status: number
      message: string
    }

    console.error(errorResponse.message)

    notification.error({
      message: t('blocktrain_status_update_error'),
    })
  }

  const { mutate: updateBlocktrainStatus } = useMutation<
    UpdateBlocktrainStatusPayload,
    AxiosErrorType,
    UpdateBlocktrainStatusPayload
  >([QUERY_KEYS.BLOCKTRAIN_STATUS_UPDATE], statusUpdate, {
    onSuccess,
    onError,
    onMutate: () => {
      setUpdateBlocktrainStatusIsFetching(true)
    },
  })

  return {
    updateBlocktrainStatus,
    updateBlocktrainStatusIsFetching,
  }
}

export default useUpdateBlocktrainStatus
